import { render, staticRenderFns } from "./QRCodeView.vue?vue&type=template&id=54504187&scoped=true"
import script from "./QRCodeView.vue?vue&type=script&lang=js"
export * from "./QRCodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54504187",
  null
  
)

export default component.exports